import PinyinMatch from 'pinyin-match';
function debounce(fn, time) {
  let timeout = null
  return function () {
    let args = arguments;
    if (timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(() => {
      fn(...args)
    }, time);
  }
}
const pinyinMatch = function(content, search) {
  return !search || PinyinMatch.match(content ? content.toLowerCase() : "", search ? search.toLowerCase() : "")
}

export default {
  debounce,
  pinyinMatch
}